<template>
  <div class="aside-block">
    <slot />
  </div>
</template>

<style lang="scss">
@use '@/styles/colors.scss';
.aside-block {
  width: 29.5em;
  background-color: colors.$main-color;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10.625em;

  h4 {
    text-align: center;
    &:after {
      content: '';
      display: block;
      background-color: colors.$white-color;
      height: 1px;
      width: 180px;
      margin-top: 0.25em;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .entries-container {
    display: flex;
    flex: 1;
    align-items: center;
    flex-direction: column;
    .entry {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 4.5em;

      i {
        font-size: 6.25em;
        margin: 0 0 0.1em;
      }
    }
    // .material-icons {
    //   font-size: 5em;
    //   margin: 0 0 0.125em;
    // }
    .caption,
    .details {
      font-size: 2em;
    }
    .details {
      opacity: 0.5;
      padding: 0 64px;
      text-align: center;
    }
  }
}
</style>
